var _ellipse, _circle, _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 371,
    height: 455,
    viewBox: "0 0 371 455",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.305,
    cy: 55.1971,
    rx: 54.2908,
    ry: 55.0892,
    transform: "rotate(90 267.305 55.1971)",
    fill: "#006A99"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.292,
    cy: 227.645,
    r: 113.372,
    transform: "rotate(90 73.292 227.645)",
    fill: "#25307F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 370.297,
    y: 75.9531,
    width: 83.033,
    height: 83.033,
    transform: "rotate(90 370.297 75.9531)",
    fill: "#25307F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47.7461,
    y: 0.90625,
    width: 226.744,
    height: 226.744,
    transform: "rotate(90 47.7461 0.90625)",
    fill: "#FF5F45"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 325.59,
    y: 227.648,
    width: 226.744,
    height: 226.744,
    transform: "rotate(90 325.59 227.648)",
    fill: "#FFA540"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.4375,
    y: 257.992,
    width: 83.033,
    height: 83.033,
    transform: "rotate(90 1.4375 257.992)",
    fill: "#006A99"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 42.957,
    y: 412.875,
    width: 41.5165,
    height: 41.5165,
    transform: "rotate(90 42.957 412.875)",
    fill: "#006A99"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpBg);
export default __webpack_public_path__ + "static/media/sp_bg.22798997dbc0b9690103b4f0bd97c674.svg";
export { ForwardRef as ReactComponent };